const _calculateSubtitleSize = (realSubtitleSize, realEyebrowSize) => {
    /* istanbul ignore else */
    if (realSubtitleSize !== undefined && realEyebrowSize === undefined) {
        return realSubtitleSize;
    }
    /* istanbul ignore else */
    if (realEyebrowSize !== undefined && realSubtitleSize === undefined) {
        return realEyebrowSize;
    }
    /* istanbul ignore else */
    if (realEyebrowSize !== undefined && realSubtitleSize !== undefined) {
        return realSubtitleSize;
    }
};
const calculateTextSize = (titleSize, subtitleSize, eyebrowSize, viewport) => {
    const sizeMap = {
        bodySmall: ['bodySmall'],
        bodyMedium: ['bodyMedium'],
        bodyLarge: ['bodyLarge'],
        title2XSmall: ['bodySmall', 'bodyMedium'],
        titleXSmall: ['bodySmall', 'bodyMedium', 'bodyLarge', 'titleXSmall'],
        titleSmall: ['bodySmall', 'bodyMedium', 'bodyLarge'],
        titleMedium: ['bodyLarge', 'bodySmall', 'bodyMedium', 'titleXSmall'],
        titleLarge: ['bodyLarge', 'bodyMedium', 'titleXSmall'],
        titleXLarge: ['titleSmall', 'bodyLarge'],
        title2XLarge: ['bodyLarge', 'titleSmall', 'titleMedium'],
        featureSmall: ['titleMedium', 'titleSmall', 'bodyLarge'],
        featureMedium: ['titleMedium', 'titleSmall', 'bodyLarge'],
    };
    const isValidTitleSize = titleSize
        ? Object.keys(sizeMap).indexOf(titleSize)
        : -1;
    const calculatedTitleSize = (isValidTitleSize > -1 && titleSize) ||
        (viewport === 'mobile' ? 'titleSmall' : 'titleMedium');
    const calculatedSubtitleSize = _calculateSubtitleSize(subtitleSize, eyebrowSize);
    const defaultSubtitleSize = calculatedTitleSize === 'titleSmall' && viewport === 'mobile'
        ? 'bodyLarge'
        : sizeMap[calculatedTitleSize][0];
    if (calculatedSubtitleSize &&
        sizeMap[calculatedTitleSize].includes(calculatedSubtitleSize)) {
        return {
            titleSize: calculatedTitleSize,
            eyebrowSize: calculatedSubtitleSize,
            subtitleSize: calculatedSubtitleSize,
        };
    }
    return {
        titleSize: calculatedTitleSize,
        eyebrowSize: defaultSubtitleSize,
        subtitleSize: defaultSubtitleSize,
    };
};

export { calculateTextSize };
